const UUID_PATTERN = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

export const isValidAuthRequestId = (authRequestId) => UUID_PATTERN.test(authRequestId ?? "");

export const getSafeRedirectUri = (redirectUri) => {
  if (!redirectUri) return null;

  try {
    const url = new URL(redirectUri);
    return url.protocol === "https:" ? url.toString() : null;
  } catch {
    return null;
  }
};

export const getRedirectUriFromResponse = (response) =>
  response?.data?.redirect_uri ?? response?.data?.data?.redirect_uri ?? null;
